import React from 'react';
import { Card } from './ui/card';
import { Award, Briefcase, GraduationCap, Code2 } from 'lucide-react';
import { profileData } from '../data/mock';

const About = () => {
  const stats = [
    { icon: Briefcase, label: 'Years Experience', value: '6+' },
    { icon: Code2, label: 'Projects Completed', value: '50+' },
    { icon: Award, label: 'Certifications', value: '10+' },
    { icon: GraduationCap, label: 'Master\'s Degree', value: 'MS' }
  ];

  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            About <span className="text-[#00AFF0]">Me</span>
          </h2>
          <div className="w-20 h-1 bg-[#00AFF0] mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Stats */}
          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat, index) => (
              <Card
                key={index}
                className="p-6 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border-2 hover:border-[#00AFF0]/50"
              >
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#00AFF0]/10 flex items-center justify-center">
                  <stat.icon className="w-8 h-8 text-[#00AFF0]" />
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-2">{stat.value}</h3>
                <p className="text-gray-600 font-medium">{stat.label}</p>
              </Card>
            ))}
          </div>

          {/* Right: Description */}
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900">
              Full-Stack Developer & Problem Solver
            </h3>
            <p className="text-gray-700 leading-relaxed text-lg">
              {profileData.about}
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-[#00AFF0] mt-2 flex-shrink-0"></div>
                <p className="text-gray-700">
                  <strong>Expertise:</strong> Specialized in migrating legacy systems to modern architectures, 
                  improving test coverage from 20% to 85%, and reducing deployment times by 40%.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-[#00AFF0] mt-2 flex-shrink-0"></div>
                <p className="text-gray-700">
                  <strong>Education:</strong> Master's degree in Big Data Analytics from Trent University, 
                  complementing strong software engineering fundamentals.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-[#00AFF0] mt-2 flex-shrink-0"></div>
                <p className="text-gray-700">
                  <strong>Location:</strong> Based in Peterborough, Ontario, Canada - 
                  actively seeking opportunities to contribute to innovative Canadian tech companies.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;